// routes.js

import HomePage from '@/components/home/HomePage.vue';
import OffersPage from "@/components/offers/OffersPage";
import FaqPage from "@/components/faq/FaqPage";
import SingleFaqPage from "@/components/faq/SingleFaqPage";
import InfoPage from "@/components/info/InfoPage";
import ContactPage from "@/components/contact/ContactPage";
import DefaultPage from "@/components/commons/DefaultPage";
import ProductPage from "@/components/offers/ProductPage";
import InfoItemPage from "@/components/info/InfoItemPage";
import DepartmentsPage from "@/components/department/DepartmentsPage";
import DepartmentPage from "@/components/department/DepartmentPage";
import ContactThanks from "@/components/commons/ContactThanks";
import OrderThanks from "@/components/commons/OrderThanks";
import BasketPage from "@/components/basket/BasketPage";
import BuyThanks from "@/components/commons/BuyThanks";
import BuyOnline from "@/components/pages/BuyOnline";

const langMapping = {
    offer: {
        pl: "/oferta",
        de: "/angebot",
        lt: "/pasiulymas",
        lv: "/piedavajums",
        ee: "/pakkumine"
    },
    offerCategory: {
        pl: "/oferta/:category",
        de: "/angebot/:category",
        lt: "/pasiulymas/:category",
        lv: "/piedavajums/:category",
        ee: "/pakkumine/:category"
    },
    product: {
        pl: "/produkt/:productName",
        de: "/produkt/:productName",
        lt: "/produktas/:productName",
        lv: "/produkts/:productName",
        ee: "/toode/:productName"
    },
    faq: {
        pl: "/faq",
        de: "/faq",
        lt: "/faq",
        lv: "/faq",
        ee: "/faq"
    },
    faqPage: {
        pl: "/faq/:pageName",
        de: "/faq/:pageName",
        lt: "/faq/:pageName",
        lv: "/faq/:pageName",
        ee: "/faq/:pageName"
    },
    info: {
        pl: "/aktualnosci",
        de: "/aktuelles",
        lt: "/naujienos",
        lv: "/jaunumi",
        ee: "/uudised"
    },
    infoPage: {
        pl: "/aktualnosci/:pageName",
        de: "/aktuelles/:pageName",
        lt: "/naujienos/:pageName",
        lv: "/jaunumi/:pageName",
        ee: "/uudised/:pageName"
    },
    contact: {
        pl: "/kontakt",
        de: "/kontakt",
        lt: "/kontaktai",
        lv: "/kontakti",
        ee: "/kontakt"
    },
    departments: {
        pl: "/oddzialy",
        de: "/filialen",
        lt: "/padaliniai",
        lv: "/filiales",
        ee: "/harukontorid"
    },
    departmentPage: {
        pl: "/oddzialy/:department",
        de: "/filialen/:department",
        lt: "/padaliniai/:department",
        lv: "/filiales/:department",
        ee: "/harukontorid/:department"
    },
    basket: {
        pl: "/koszyk",
        de: "/warenkorb",
        lt: "/krepselis",
        lv: "/grozs",
        ee: "/ostukorv"
    },
    buyThanks: {
        pl: "/platnosc-zakonczona",
        de: "/zahlung-abgeschlossen",
        lt: "/apmokejimas-baigtas",
        lv: "/apmaksa-pabeigta",
        ee: "/makse-lopetatud"
    },
    contactThanks: {
        pl: "/dziekujemy-za-kontakt",
        de: "/danke-fur-den-kontakt",
        lt: "/dekojame-uz-kontakta",
        lv: "/paldies-par-kontaktu",
        ee: "/aitah-kontakti-eest"
    },
    orderThanks: {
        pl: "/dziekujemy-za-zamowienie",
        de: "/danke-fur-die-bestellung",
        lt: "/dekojame-uz-pateikima",
        lv: "/paldies-par-pasutijumu",
        ee: "/aitah-teenuse-ostmise-eest"
    },
    buyOnline: {
        pl: "/wynajem-kabin",
        de: "/kabinen-mieten",
        lt: "/kabiniu-nuoma",
        lv: "/kabinu-noma",
        ee: "/kabini-rentimine"
    },
    service: {
        pl: "/serwis",
        de: "/service",
        lt: "/aptarnavimas",
        lv: "/apkope",
        ee: "/hooldus"
    },
    regulation: {
        pl: "/regulamin",
        de: "/bedingungen",
        lt: "/taisykles",
        lv: "/noteikumi-un-nosacijumi",
        ee: "/reeglid"
    },
    privacyPolicy: {
        pl: "/polityka-prywatnosci",
        de: "/datenschutzerklarung",
        lt: "/privatumo-politika",
        lv: "/privatuma-politiku",
        ee: "/privaatsuspoliitikale"
    },
    about: {
        pl: "/o-firmie",
        de: "/uber-uns",
        lt: "/apie-imone",
        lv: "/par-uznemumu",
        ee: "/ettevottest"
    },
    career: {
        pl: "/praca",
        de: "/karriere",
        lt: "/darbas",
        lv: "/karjera",
        ee: "/too"
    },
    priceCalculation: {
        pl: "/jak-wyliczyc-cene",
        de: "/wie-berechne-ich-den-preis",
        lt: "/kaip-skaiciuoti-kaina",
        lv: "/ka-aprekinat-cenu",
        ee: "/kuidas-arvutada-hinda"
    }
}

let routes = [
    {
        name: 'home',
        path: '/',
        component: HomePage,
    },
    {
        name: 'offer',
        path: '/oferta',
        component: OffersPage,
    },
    {
        name: 'offerCategory',
        path: '/oferta/:category',
        component: OffersPage,
    },
    {
        name: 'product',
        path: '/produkt/:productName',
        component: ProductPage,
    },
    {
        name: 'faq',
        path: '/faq',
        component: FaqPage,
    },
    {
        name: 'faqPage',
        path: '/faq/:pageName',
        component: SingleFaqPage,
    },
    {
        name: 'info',
        path: '/aktualnosci',
        component: InfoPage,
    },
    {
        name: 'infoPage',
        path: '/aktualnosci/:pageName',
        component: InfoItemPage,
    },
    {
        name: 'contact',
        path: '/kontakt',
        component: ContactPage,
    },
    {
        name: 'departments',
        path: '/oddzialy',
        component: DepartmentsPage,
    },
    {
        name: 'departmentPage',
        path: '/oddzialy/:department',
        component: DepartmentPage,
    },
    {
        name: 'basket',
        path: '/koszyk',
        component: BasketPage,
    },
    {
        name: 'buyThanks',
        path: '/platnosc-zakonczona',
        component: BuyThanks
    },
    {
        name: 'contactThanks',
        path: '/dziekujemy-za-kontakt',
        component: ContactThanks
    },
    {
        name: 'orderThanks',
        path: '/dziekujemy-za-zamowienie',
        component: OrderThanks
    },
    {
        name: 'buyOnline',
        path: '/wynajem-kabin',
        component: BuyOnline
    },
    {
        name: 'service',
        path: '/serwis',
        component: DefaultPage
    },
    {
        name: 'regulation',
        path: '/regulamin',
        component: DefaultPage
    },
    {
        name: 'privacyPolicy',
        path: '/polityka-prywatnosci',
        component: DefaultPage
    },
    {
        name: 'about',
        path: '/o-firmie',
        component: DefaultPage
    },
    {
        name: 'career',
        path: '/praca',
        component: DefaultPage
    },
    {
        name: 'priceCalculation',
        path: '/jak-wyliczyc-cene',
        component: DefaultPage
    },
    {
        name: 'defaultPage',
        path: '/*',
        component: DefaultPage
    }
];

function getRoutes(lang) {
    routes.forEach(route => {
        if (langMapping[route.name] && langMapping[route.name][lang]) {
            route.path = langMapping[route.name][lang];
        }
    });

    return routes;
}


export default getRoutes;
